
export class FMRegisterHazardMaterial {
  id: string;
  requestStatusName: string;
  requestStatusId: number;
  requestorName: string;
  requestId: number;
  requestNumber: string;
  requestType: string;
  requestTypeId: number;
  chemicalName: string;
  unNumber: string;
  materialStateId: number;
  materialPackagingId: number;
  size: number;
  amount: number;
  materialStateName: string;
  materialPackagingName: string;
  unitsId: number;
  unitsName: string;
  registeredDate: Date;
  otherMaterialPackaging : string ;
  otherMaterialState : string;
  quantityInStock: number;
  companyName: string;
}




// WEBPACK FOOTER //
// ./src/app/core/models/fm-register-hazard-material.ts